/**
 * SupportUltronsSentries.js
 * The Support Ultrons Sentries Enemy class
 */

import { Game } from "pixi_core";
import { EnemyAbilities, GameEvents } from "../Constants";
import { Enemy } from "./Enemy";

export class SupportUltronsSentries extends Enemy {
    /**
     * @public
     * @param {String} enemyName
     * @param {Object} enemyData
     * @param {Number} index
     * @param {Boolean} [summoned] - Summoned by an ability
     */
    constructor(enemyName, enemyData, index, summoned) {
        super(enemyName, enemyData, index, summoned);

        const probJam = Game.utils.assertNumber(enemyData.ProbJam, 1);
        const probRepair = Game.utils.assertNumber(enemyData.ProbRepair, 1);
        const probAddOvertime = Game.utils.assertNumber(enemyData.ProbAddOvertime, 1);

        // Single ability choice
        this._abilityChoices.addChoice(EnemyAbilities.eJAM, probJam);
        this._abilityChoices.addChoice(EnemyAbilities.eREPAIR, probRepair);
        this._abilityChoices.addChoice(EnemyAbilities.eULTRON_CONTROL, probAddOvertime);

        /** @private @type {Number} - Healing percentage when using the Repair ability */
        this._repairPercent = Game.utils.assertNumber(enemyData.RepairPercent, 1);
    }

    /**
     * @protected
     * @override
     * @param {EnemyAbilities} abilityName
     * @param {{x: Number, y: Number}} startPos
     */
    _useAbility(abilityName, startPos) {
        switch (abilityName) {
            case EnemyAbilities.eJAM:
                Game.fire(GameEvents.eGAME_ABILITY_JAM, this._stunNumber, this._stunTurns, startPos, this._onAbilityCompleted.bind(this));
                break;
            case EnemyAbilities.eREPAIR:
                Game.fire(GameEvents.eGAME_ABILITY_REPAIR, this._repairPercent, this._onAbilityCompleted.bind(this));
                break;
            case EnemyAbilities.eULTRON_CONTROL:
                Game.fire(GameEvents.eGAME_ABILITY_ADD_OVERTIME, this._addOvertimeBubbles, this._onAbilityCompleted.bind(this));
                break;
            default:
                console.error("[SupportUltronsSentries._useAbility] Invalid ability name : " + abilityName);
                this._chooseNextAction();
        }
    }
}
